import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { filter, map, take, tap } from 'rxjs';
import { PushNotificationsFacade } from '../facades/push-notifications.facade';

export function pushNotificationsStateLoaded(): CanActivateFn {
    return () => {
        const pushNotificationsFacade = inject(PushNotificationsFacade);

        return pushNotificationsFacade.loaded$.pipe(
            tap((loaded) => {
                if (loaded === null) {
                    pushNotificationsFacade.status();
                }
            }),
            filter((loaded) => loaded !== null),
            take(1),
            map(() => true),
        );
    };
}
